import { initAdyenCheckout } from 'features/adyen/duck/actions'
import { PaymentData } from 'features/checkout/types'
import { initCybersourceCheckout } from 'features/cybersource/duck/actions'
import {
  setPaymentsInitStart as setKlarnaPaymentsInitStart,
  setPaymentsInitSuccess as setKlarnaPaymentsInitSuccess,
  setPaymentsInitFail as setKlarnaPaymentsInitFail,
} from 'features/klarna/duck/actions'
import klarnaPaymentsInitialize from 'features/klarna/helpers/klarnaPaymentsInitialize'
import { initRazorpayCheckout } from 'features/razorpay/duck/actions'
import { ThunkResult } from 'redux/types'

export const initKlarnaPayments =
  (klarnaClientToken: string): ThunkResult<Promise<void>> =>
  async (dispatch) => {
    if (klarnaClientToken) {
      dispatch(setKlarnaPaymentsInitStart())
      const [klarnaInitLoaded, klarnaInitError] = await klarnaPaymentsInitialize(klarnaClientToken)
      if (klarnaInitLoaded && !klarnaInitError) {
        dispatch(setKlarnaPaymentsInitSuccess())
      } else {
        dispatch(setKlarnaPaymentsInitFail())
      }
    }
  }

export const operationInitPayments =
  (
    paymentData: PaymentData = {
      adyenPaymentData: undefined,
      cybersourcePaymentData: undefined,
      klarnaData: undefined,
      razorpayData: undefined,
    },
  ): ThunkResult<Promise<void>> =>
  async (dispatch) => {
    const { adyenPaymentData, cybersourcePaymentData, klarnaData, razorpayData } = paymentData

    if (cybersourcePaymentData) {
      dispatch(initCybersourceCheckout({ keyId: cybersourcePaymentData.keyId }))
    }

    if (adyenPaymentData) {
      dispatch(initAdyenCheckout({ config: adyenPaymentData }))
    }

    if (klarnaData) {
      dispatch(initKlarnaPayments(klarnaData.klarnaClientToken))
    }

    if (razorpayData) {
      dispatch(initRazorpayCheckout(razorpayData))
    }
  }
